module.exports = __webpack_public_path__ + "static/media/Tickets-Banner.358c00d7.jpg";